/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import UnionComponent from 'Components/union/unionComponent';
import fpListActions from 'Actions/taskManage/firstPage';
import StaticOverview from './staticOverview';
import OutStatus from './outStatus';

import './index.less';

class FirstPage extends UnionComponent {
  render() {
    return (
      <div className="taskManageFirstPage">
        <StaticOverview />
        <OutStatus />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  taskManageFirstPage: state.taskManageFirstPage,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(fpListActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FirstPage);
